import { useMemo } from "react";
import { makeApi } from "./api";
import { useAuthToken } from "./auth";

export function useApi() {
  const { token, logout } = useAuthToken();
  return useMemo(() => makeApi(() => token, logout), [token, logout]);
}
